import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
  Collapse,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { ArrowRight, ArrowDown } from "react-feather";
import axios from "axios";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { UsersData } from "src/ContextAPI";
import IsMountedRef from "src/utils/IsMountedRef";
import Notify from "src/notification/Notify";

const InvoiceForApproval = () => {
  const [products, setProducts] = useState({ data: [], ready: false });
  const [selectedProduct, setSelectedProduct] = useState("");
  const mounted = IsMountedRef();
  const { users } = useContext(UsersData);
  const [approved, setApproved] = useState({ data: "", dialog: false });

  const [invoiceDetails, setInvoiceDetails] = useState({
    data: [],
    ready: true,
  });

  const getInvoiceForApproval = React.useCallback(async () => {
    let response = await axios.get("accounting/invoice/for-approval", {
      params: {
        management_id: users.management_id,
      },
    });

    if (mounted.current) {
      setProducts({ data: response.data, ready: true });
    }
  }, [users, mounted]);

  const handleSelectedInvoice = async (xinfo) => {
    let response = await axios.get("accounting/invoice/for-approval-details", {
      params: {
        management_id: users.management_id,
        invoice_number: xinfo.invoice_number,
      },
    });

    setInvoiceDetails({ data: response.data, ready: true });
    setSelectedProduct(xinfo);
  };

  const handleInvoiceApproved = async () => {
    var formdata = new FormData();
    formdata.set("management_id", users.management_id);
    formdata.set("invoice_number", approved.data.invoice_number);

    let response = await axios.post(
      "accounting/invoice/approved-byaccounting",
      formdata
    );

    if (response.data.message === "success") {
      Notify.successRequest("Invoice Approved");
      getInvoiceForApproval();
      setApproved({ data: "", dialog: false });
    }
  };

  useEffect(() => {
    getInvoiceForApproval();
  }, [getInvoiceForApproval]);

  return (
    <Paper>
      <Box p={2}>
        <Typography variant="h6" color="textSecondary">
          Invoice for approval
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell> Date </TableCell>
                <TableCell> Invoice </TableCell>
                <TableCell> Delivered by </TableCell>
                <TableCell> Action </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {products.ready ? (
                products.data.length > 0 ? (
                  products.data.map((data, index) => (
                    <Fragment key={index}>
                      <TableRow>
                        <TableCell>
                          <IconButton
                            disabled={
                              selectedProduct.invoice_number ===
                              data.invoice_number
                            }
                            color="primary"
                            onClick={() => handleSelectedInvoice(data)}
                          >
                            {selectedProduct.invoice_number ===
                            data.invoice_number ? (
                              <ArrowDown />
                            ) : (
                              <ArrowRight />
                            )}
                          </IconButton>
                        </TableCell>

                        <TableCell>
                          {Notify.dateTimeConvert(data.created_at)}
                        </TableCell>

                        <TableCell> {data.invoice_number} </TableCell>

                        <TableCell> {data.delivered_by} </TableCell>

                        <TableCell>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              setApproved({ data: data, dialog: true })
                            }
                          >
                            Approve Invoice
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={5} style={{ border: 0 }}>
                          <Collapse
                            in={
                              selectedProduct.invoice_number ===
                              data.invoice_number
                            }
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box margin={1}>
                              <Typography variant="subtitle1" gutterBottom>
                                <strong> Invoice Products </strong>
                              </Typography>

                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell> Product </TableCell>
                                    <TableCell> Generic </TableCell>
                                    <TableCell> Batch </TableCell>
                                    <TableCell> Mfg. Date </TableCell>
                                    <TableCell> Exp. Date </TableCell>
                                    <TableCell> Qty </TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {invoiceDetails.ready ? (
                                    invoiceDetails.data.length > 0 ? (
                                      invoiceDetails.data.map((data, index) => (
                                        <TableRow key={index}>
                                          <TableCell>
                                            {data.product_name}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_generic}
                                          </TableCell>
                                          <TableCell>
                                            {data.batch_number}
                                          </TableCell>
                                          <TableCell>
                                            {data.manufactured_date}
                                          </TableCell>
                                          <TableCell>
                                            {data.expiration_date}
                                          </TableCell>
                                          <TableCell align="right">
                                            {data.qty}
                                          </TableCell>
                                        </TableRow>
                                      ))
                                    ) : (
                                      <TableRow>
                                        <TableCell colSpan={6}>
                                          <Typography color="secondary">
                                            No product added.
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    )
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={6}>
                                        <Typography color="primary">
                                          loading, please wait...
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography color="secondary">
                        No product added.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography color="primary">
                      loading, please wait...
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* approved dr dialog */}
      <Dialog
        open={approved.dialog}
        onClose={() => setApproved({ data: null, dialog: false })}
      >
        <DialogContent>Are you sure to approve this invoice?</DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setApproved({ data: null, dialog: false })}
          >
            No
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleInvoiceApproved()}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default InvoiceForApproval;
